import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';
import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as undoActions from '../../undo/actions/undo.actions';
import * as stripActions from '../actions/strip.actions';
import { VisibleStrip } from '../types/strip.type';

export type StripState = EntityState<VisibleStrip>;

declare module 'react-redux' {
  interface DefaultRootState {
    strip: StripState;
  }
}

const stripAdapter = createEntityAdapter<VisibleStrip>();

export const { selectAll, selectById } = stripAdapter.getSelectors();

export default reducer(
  stripAdapter.getInitialState(),
  on(ecgActions.clean, () => stripAdapter.getInitialState()),
  on(stripActions.register, (state, { strip }) => {
    const existingStrip = selectById(state, strip.id) || strip;
    return stripAdapter.upsertOne(state, {
      ...existingStrip,
      visible: true,
      duration: strip.duration,
      offset: strip.offset,
      onset: strip.onset,
      durationOffset: strip.durationOffset,
    });
  }),
  on(stripActions.unregister, (state, { stripId }) =>
    stripAdapter.updateOne(state, {
      id: stripId,
      changes: { visible: false, onset: 0, offset: 0 },
    }),
  ),
  on(stripActions.update, (state, { stripId, strip }) =>
    stripAdapter.updateOne(state, {
      id: stripId,
      changes: strip,
    }),
  ),
  on(stripActions.incrementGain, (state, { stripId, value }) => {
    const strip = state.entities[stripId];
    if (!strip) {
      return state;
    }

    return stripAdapter.updateOne(state, {
      id: stripId,
      changes: { gain: strip.gain * 2 ** value },
    });
  }),
  on(undoActions.undo, undoActions.restore, (state, { diff: { strip } }) => {
    if (!strip) {
      return state;
    }
    return { ...state, ...strip };
  }),
);
